export default __webpack_public_path__ + "static/media/cp_crm_crm.72f0fcc7.svg";